/* eslint-disable import/prefer-default-export */
import apiClient from './apiClient';
import { GET_FONTS } from '../constants/UriConstants';
import { GetFontsResponseInterface } from '../types/FontInterface';

export const getFonts = (): Promise<GetFontsResponseInterface> =>
  apiClient.get(GET_FONTS).then((response) => response.data);
